module.exports = __webpack_public_path__ + "img/blank-profile-picture-g95ac279a6_640.5a021ab9.png";